import exceljs from "exceljs";
import { saveAs } from "file-saver";
//---------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    onlyUnique, 
    outsideHolidays, 
    getDatefromWeekNum, 
    defaultEmptyPMNumber, 
    mimeTypeMap, 
    numberReducer, 
    arrayReducer, 
    round,
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function DataReport({
    filteredForms, 
    week, 
}){
    const filterFormsByWeekByPerson = filteredForms; // not creating new array, just asign address to this constant varibable
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const regOT = (day, dayIndex) => {
        const jobs = day.filter(event => event.category !== "lunch");
        if(jobs.length && jobs[0].outside === "locator"){
            if(dayIndex > 4 || outsideHolidays.map(holiday => holiday.date).includes(
                getDatefromWeekNum(week, dayIndex)
            )){
                return jobs.map(job => ({
                    ...job, 
                    regular: 0, 
                    ot: round((job.mins || 0) / 60, 2)
                }));
            }else{
                let totalHours = 0;
                if(jobs[0].mobInFrom === "Hotel"){
                    totalHours += round(jobs[0].mobInTime / 60, 2);
                }else{
                    if(jobs[0].mobInTime > 60){
                        totalHours += round((jobs[0].mobInTime - 60) / 60, 2);
                    }
                }
                for(let jobIndex = 0; jobIndex < jobs.length; jobIndex++){
                    const hours = round((jobs[jobIndex].mins || 0) / 60, 2);
                    if(totalHours <= 8 && totalHours + hours >= 8){
                        jobs[jobIndex].regular = 8 - totalHours;
                        jobs[jobIndex].ot = hours - (8 - totalHours);
                    }else if(totalHours <= 8){
                        jobs[jobIndex].regular = hours;
                        jobs[jobIndex].ot = 0;
                    }else if(totalHours > 8){
                        jobs[jobIndex].regular = 0;
                        jobs[jobIndex].ot = hours;
                    }
                    totalHours += hours;
                }
                return jobs;
            }
        }else{
            return jobs;
        }
    }
    const addHoursSheet = (workbook, mainData, headerArr) => {
        const worksheet = workbook.addWorksheet("Effective Hours");
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        worksheet.getColumn(1).values = headerArr;
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            const regularArr = mainData.map(
                form => form.form[weekIndex].workStatus === "Work"?
                (form.form[weekIndex]?.regular ?? 0) : 0
            );
            const oTArr = mainData.map(form => form.form[weekIndex].workStatus === "Work"?
                (form.form[weekIndex]?.ot ?? 0) : 0
            );
            worksheet.getColumn(2 * weekIndex + 2).values = [
                `${getDatefromWeekNum(week, weekIndex)} Regular`,...regularArr
            ];
            worksheet.getColumn(2 * weekIndex + 3).values = [
                `${getDatefromWeekNum(week, weekIndex)} OT`,...oTArr
            ];
        }
        const totalRegularArr = mainData.map(
            form => form.form.map(
                day => day.workStatus === "Work" ? (day.regular || 0) : 0
            ).reduce(numberReducer, 0)
        );
        const totalOTArr = mainData.map(
            form => form.form.map(
                day => day.workStatus === "Work" ? (day.ot || 0) : 0
            ).reduce(numberReducer, 0)
        );
        worksheet.getColumn(2 * 7 + 2).values = [
            `Total Regular`,...totalRegularArr
        ];
        worksheet.getColumn(2 * 7 + 3).values = [`Total OT`,...totalOTArr];
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // cell.numFmt = "0.00";
                const columnLength = cell.value?
                cell.value.toString().length * (
                    cell.font?cell.font.size / 11 * 1.2:1.1
                )
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const addMileageSheet = (workbook, mainData, headerArr) => {
        const worksheet2 = workbook.addWorksheet("Mileage");
        worksheet2.state = "visible";
        worksheet2.properties.defaultColWidth = 22.57;
        worksheet2.getColumn(1).values = headerArr;
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            const mobInOdometer = mainData.map(
                form => window.Number.parseFloat(form.form[weekIndex]?.mobInOdometer ?? 0)
            );
            const mobOutOdometer = mainData.map(
                form => window.Number.parseFloat(form.form[weekIndex]?.mobOutOdometer ?? 0)
            );
            const odometer = mainData.map(
                form => window.Number.parseFloat(form.form[weekIndex]?.mobOutOdometer ?? 0) - 
                window.Number.parseFloat(form.form[weekIndex]?.mobInOdometer ?? 0)
            );
            worksheet2.getColumn(3 * weekIndex + 2).values = [
                `${getDatefromWeekNum(week, weekIndex)} Mob In`,...mobInOdometer
            ];
            worksheet2.getColumn(3 * weekIndex + 3).values = [
                `${getDatefromWeekNum(week, weekIndex)} Mob Out`,...mobOutOdometer
            ];
            worksheet2.getColumn(3 * weekIndex + 4).values = [
                `${getDatefromWeekNum(week, weekIndex)} Mileage`,...odometer
            ];
        }
        const totalMilage = mainData.map(
            form => form.form.map(
                day => window.Number.parseFloat(day?.mobOutOdometer ?? 0) - 
                window.Number.parseFloat(day?.mobInOdometer ?? 0)
            ).reduce(numberReducer, 0)
        );
        worksheet2.getColumn(3 * 7 + 2).values = [
            `Total Mileage`,...totalMilage
        ];
        worksheet2.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (
                    cell.font?cell.font.size / 11 * 1.2:1.1
                )
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const addTollsSheet = (workbook, mainData, headerArr) => {
        const worksheet21 = workbook.addWorksheet("Tolls Paid");
        worksheet21.state = "visible";
        worksheet21.properties.defaultColWidth = 22.57;
        worksheet21.getColumn(1).values = headerArr;
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            worksheet21.getColumn(weekIndex + 2).values = [
                `${getDatefromWeekNum(week, weekIndex)} Tolls Paid`,
                ...mainData.map(
                    form => form.form[weekIndex]?.tollPaid ?? 0
                )
            ];
        }
        worksheet21.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (
                    cell.font?cell.font.size / 11 * 1.2:1.1
                )
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const addSubsitenceSheet = (workbook, mainData, headerArr) => {
        const worksheet3 = workbook.addWorksheet("Subsistence Payroll");
        worksheet3.state = "visible";
        worksheet3.properties.defaultColWidth = 22.57;
        worksheet3.getColumn(1).values = headerArr;
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            const workStatus = mainData.map(form => form.form[weekIndex]?.workStatus ?? "");
            worksheet3.getColumn(weekIndex + 2).values = [
                `${getDatefromWeekNum(week, weekIndex)}`,...workStatus
            ];
        }
        worksheet3.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (
                    cell.font?cell.font.size / 11 * 1.2:1.1
                )
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const addSubsitenceBillableSheet = (workbook, mainData, headerArr) => {
        const worksheet31 = workbook.addWorksheet("Subsistence Billable");
        worksheet31.state = "visible";
        worksheet31.properties.defaultColWidth = 22.57;
        worksheet31.getColumn(1).values = headerArr;
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            const workStatus = mainData.map(form => 
                form.form[weekIndex].workStatus === "Work"?
                form.form[weekIndex]?.data.find(event => 
                    event.category !== "lunch" && 
                    !["02055506", "02051446", defaultEmptyPMNumber].includes(event.pmNumber)
                )?.pmNumber ?? defaultEmptyPMNumber
                :
                ""
            );
            worksheet31.getColumn(weekIndex + 2).values = [
                `${getDatefromWeekNum(week, weekIndex)}`, 
                ...workStatus
            ];
        }
        worksheet31.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (
                    cell.font?cell.font.size / 11 * 1.2:1.1
                )
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const addLocatorSheet = (workbook, title) => {
        const pmNumbersForLM = filterFormsByWeekByPerson
        .map(form => ({
            ...form[week], 
            email: form.email, 
            userName: form.userName.replace(/ {2}/g, " "), 
            outside: form.outside,
            outsideTimeCards: form.outsideTimeCards
        }))
        .filter(form => form.outsideTimeCards?.split(", ").includes(title) ?? false
        //&& form.status === "Submitted"
        )
        .map(form => form.form)
        .reduce(arrayReducer, [])
        .map(day => day.data)
        .reduce(arrayReducer, [])
        .filter(event => event.category !== "lunch" && event.pmNumber)
        .map(evnet => evnet.pmNumber)
        .filter(onlyUnique);
        if(!pmNumbersForLM.includes(defaultEmptyPMNumber)){
            pmNumbersForLM.unshift(defaultEmptyPMNumber);
        }
        // ---- pm hours ----
        const daysByWeekdayByPersonLM = filterFormsByWeekByPerson
        .map(form => ({
            ...form[week], 
            email: form.email, 
            userName: form.userName.replace(/ {2}/g, " "), 
            outside: form.outside, 
            outsideTimeCards: form.outsideTimeCards
        }))
        .filter(form => form.outsideTimeCards?.split(", ").includes(title) ?? false
        //&& raw.status === "Submitted"
        )
        .map(form => ({
            form: form.form, 
            email: form.email, 
            userName: form.userName.replace(/ {2}/g, " "), 
            outside: form.outside, 
            outsideTimeCards: form.outsideTimeCards
        }))
        .map(form => form.form.map(day => ({
            ...day, 
            email: form.email, 
            userName: form.userName.replace(/ {2}/g, " "), 
            outside: form.outside, 
            outsideTimeCards: form.outsideTimeCards
        })));
        const worksheet = workbook.addWorksheet(title); // *
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const pmHeaderArr = ["PMs",...pmNumbersForLM]; // *
        worksheet.getColumn(1).values = pmHeaderArr;
         /* ---- pm hours ---- */
        const storage1 = [];
        const storage2 = [];
        const storage3 = [];
        const storage4 = [];
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            const eventsForHours = daysByWeekdayByPersonLM.map(daysByWeekday => daysByWeekday[weekIndex])
            .map(day => day.workStatus !== "Work"?{
                data:[],
                id:day.id,
                overnight: false,
                status:day.status
            }:day)
            .map(day => day.data.map(event => ({
                ...event, 
                mobInFrom: day.mobInFrom,
                mobInTime: day.mobInTime,
                outside: day.outside
            })))
            .map(day => regOT(day, weekIndex))
            .reduce(arrayReducer, [])
            .map(
                event => event.category === "event" && !event.pmNumber?
                {
                    ...event, 
                    pmNumber: defaultEmptyPMNumber
                }: event
            );
            //------------------
            const daysForMob = daysByWeekdayByPersonLM.map(daysByWeekday => daysByWeekday[weekIndex])
            .map(day => day.workStatus !== "Work"?{
                data:[],
                id:day.id,
                overnight: false,
                status:day.status
            }:day)
            //------------------
            const regularMobArr = pmNumbersForLM.map(
                pmNumber => daysForMob.filter(
                    day => day.mobInTimePM === pmNumber
                ).map(day => Math.max(0, day.mobInReg) || 0).reduce(numberReducer, 0)
                + 
                daysForMob.filter(
                    day => day.mobOutTimePM === pmNumber
                ).map(day => Math.max(0, day.mobOutReg) || 0).reduce(numberReducer, 0)
            ).map(x => round(x, 2));
            const oTMobArr = pmNumbersForLM.map(
                pmNumber => daysForMob.filter(
                    day => day.mobInTimePM === pmNumber
                ).map(day => Math.max(0, day.mobInOT) || 0).reduce(numberReducer, 0)
                + 
                daysForMob.filter(
                    day => day.mobOutTimePM === pmNumber
                ).map(day => Math.max(0, day.mobOutOT) || 0).reduce(numberReducer, 0)
            ).map(x => round(x, 2));
            const regularArr = pmNumbersForLM.map(
                pmNumber => eventsForHours.filter(
                    event => event.pmNumber === pmNumber
                ).map(day => Math.max(0, day.regular) || 0).reduce(numberReducer, 0)
            ).map(x => round(x, 2));
            const oTArr = pmNumbersForLM.map(
                pmNumber => eventsForHours.filter(
                    event => event.pmNumber === pmNumber
                ).map(day => Math.max(0, day.ot) || 0).reduce(numberReducer, 0)
            ).map(x => round(x, 2));
            storage1.push(regularArr);
            storage2.push(oTArr);
            storage3.push(regularMobArr);
            storage4.push(oTMobArr);
            worksheet.getColumn(4 * weekIndex + 2).values = [`${getDatefromWeekNum(week, weekIndex)} Regular`,...regularArr];
            worksheet.getColumn(4 * weekIndex + 3).values = [`${getDatefromWeekNum(week, weekIndex)} OT`,...oTArr];
            worksheet.getColumn(4 * weekIndex + 4).values = [`${getDatefromWeekNum(week, weekIndex)} Mob Regular`,...regularMobArr];
            worksheet.getColumn(4 * weekIndex + 5).values = [`${getDatefromWeekNum(week, weekIndex)} Mob OT`,...oTMobArr];
        }
        const total1 = [];
        const total2 = [];
        const total3 = [];
        const total4 = [];
        for(let i = 0; i < storage1[0].length; i++){
            total1.push(storage1[0][i] + storage1[1][i] + storage1[2][i] + storage1[3][i] + storage1[4][i] + storage1[5][i] + storage1[6][i]);
            total2.push(storage2[0][i] + storage2[1][i] + storage2[2][i] + storage2[3][i] + storage2[4][i] + storage2[5][i] + storage2[6][i]);
            total3.push(storage3[0][i] + storage3[1][i] + storage3[2][i] + storage3[3][i] + storage3[4][i] + storage3[5][i] + storage3[6][i]);
            total4.push(storage4[0][i] + storage4[1][i] + storage4[2][i] + storage4[3][i] + storage4[4][i] + storage4[5][i] + storage4[6][i]);
        }
        worksheet.getColumn(4 * 7 + 2).values = [`Total Regular`,...total1];
        worksheet.getColumn(4 * 7 + 3).values = [`Total OT`,...total2];
        worksheet.getColumn(4 * 7 + 4).values = [`Total Mob Regular`,...total3];
        worksheet.getColumn(4 * 7 + 5).values = [`Total Mob OT`,...total4];
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                /* cell.numFmt = "0.00"; */
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const addMobSheet = (workbook, mainData) => {
        const worksheet6 = workbook.addWorksheet("Mob Hours");
        worksheet6.state = "visible";
        worksheet6.properties.defaultColWidth = 22.57;
        const headerArr6 = [
            "Employee", 
            ...mainData.map(form => form.userName.replace(/ {2}/g, " "))
        ];
        worksheet6.getColumn(1).values = headerArr6;
        for(let weekIndex = 0; weekIndex < 7; weekIndex++){
            const regularArr = mainData.map(
                form => form.form[weekIndex].workStatus === "Work"?
                (form.form[weekIndex]?.regular ?? 0) : 0
            );
            const regularMobArr = mainData.map(
                form => form.form[weekIndex].workStatus === "Work"?
                (form.form[weekIndex]?.mobReg ?? 0) : 0
            );
            const regularMobPercentArr = mainData.map(
                form => form.form[weekIndex].workStatus === "Work" && (form.form[weekIndex]?.regular ?? 0) !== 0?
                (form.form[weekIndex]?.mobReg ?? 0) / form.form[weekIndex]?.regular : ""
            );
            const oTArr = mainData.map(form => form.form[weekIndex].workStatus === "Work"?
                (form.form[weekIndex]?.ot ?? 0) : 0
            );
            const oTMobArr = mainData.map(
                form => form.form[weekIndex].workStatus === "Work"?
                (form.form[weekIndex]?.mobOT ?? 0) : 0
            );
            const oTMobPercentArr = mainData.map(form => form.form[weekIndex].workStatus === "Work" && (form.form[weekIndex]?.ot ?? 0) !== 0?
                (form.form[weekIndex]?.mobOT ?? 0) / form.form[weekIndex]?.ot : ""
            );
            worksheet6.getColumn(6 * weekIndex + 2).values = [
                `${getDatefromWeekNum(week, weekIndex)} Regular`,...regularArr
            ];
            worksheet6.getColumn(6 * weekIndex + 3).values = [
                `${getDatefromWeekNum(week, weekIndex)} Regular Mob`,...regularMobArr
            ];
            // worksheet6.getColumn(6 * weekIndex + 3).numFmt = "0.00";
            worksheet6.getColumn(6 * weekIndex + 4).values = [
                `${getDatefromWeekNum(week, weekIndex)} Regular Percent`,...regularMobPercentArr
            ];
            worksheet6.getColumn(6 * weekIndex + 4).numFmt = "0.00%";
            worksheet6.getColumn(6 * weekIndex + 5).values = [
                `${getDatefromWeekNum(week, weekIndex)} OT`,...oTArr
            ];
            worksheet6.getColumn(6 * weekIndex + 6).values = [
                `${getDatefromWeekNum(week, weekIndex)} OT Mob`,...oTMobArr
            ];
            // worksheet6.getColumn(6 * weekIndex + 6).numFmt = "0.00";
            worksheet6.getColumn(6 * weekIndex + 7).values = [
                `${getDatefromWeekNum(week, weekIndex)} OT Percent`,...oTMobPercentArr
            ];
            worksheet6.getColumn(6 * weekIndex + 7).numFmt = "0.00%";
        }
        const totalRegularArr6 = mainData.map(
            form => form.form.map(
                day => day.workStatus === "Work" && (day.regular || 0)
            ).reduce(numberReducer, 0)
        );
        const totalOTArr6 = mainData.map(
            form => form.form.map(
                day => day.workStatus === "Work" && (day.ot || 0)
            ).reduce(numberReducer, 0)
        );
        worksheet6.getColumn(6 * 7 + 2).values = [
            `Total Regular`,...totalRegularArr6
        ];
        worksheet6.getColumn(6 * 7 + 3).values = [`Total OT`,...totalOTArr6];
        worksheet6.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (
                    cell.font?cell.font.size / 11 * 1.2:1.1
                )
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
    }
    const formatCsvCell = (value) => {
        const str = String(value ?? "");
        return str.includes(",") || str.includes("\"") || str.includes("\n")?
            `"${str.replace(/"/g, "\"\"")}"` : str;
    };
    const handleCsvExport = () => {
        setShowLoader(true);
        const header = [
            "EE ID", "Employee Name", "Date", "Time Type", "Hours", 
            "Job Name", "Job Code", "Activity"
        ];
        const rowsByEmployee = filterFormsByWeekByPerson.map(person => {
            const userName = person.userName.replace(/ {2}/g, " ");
            const employeeId = person.employee_id ?? "";
            const dayRows = [];
            const form = person[week]?.form ?? [];
            for(let dayIndex = 0; dayIndex < 7; dayIndex++){
                const day = form[dayIndex];
                if(!day || day.workStatus !== "Work") continue;
                const date = getDatefromWeekNum(week, dayIndex);
                const regular = round(day.regular ?? 0, 2);
                const ot = round(day.ot ?? 0, 2);
                if(regular > 0){
                    dayRows.push([employeeId, userName, date, "Regular", regular, "", "", ""]);
                }
                if(ot > 0){
                    dayRows.push([employeeId, userName, date, "OT", ot, "", "", ""]);
                }
            }
            dayRows.sort((a, b) => b[2].localeCompare(a[2]));
            return dayRows;
        });
        const csv = [
            header.join(","),
            ...rowsByEmployee.flat().map(row => row.map(formatCsvCell).join(",")),
        ].join("\n");
        saveAs(new Blob([csv], { type: mimeTypeMap.csv }), `outside_service_${week}.csv`);
        setShowLoader(false);
    };
    const handleDataReport = () => {
        setShowLoader(true);
        const mainData = filterFormsByWeekByPerson
        .map(raw => ({
            ...raw[week], 
            email: raw.email, 
            userName: raw.userName.replace(/ {2}/g, " "), 
            outside: raw.outside, 
            outsideTimeCards: raw.outsideTimeCards
        }))
        //.filter(raw => raw.status === "Submitted")
        .map(raw => ({
            form: raw.form, 
            email: raw.email, 
            userName: raw.userName.replace(/ {2}/g, " "), 
            outside: raw.outside, 
            outsideTimeCards: raw.outsideTimeCards
        }));
        //-------------------------------------------
        const headerArr = [
            "Employee",
            ...mainData.map(form => form.userName.replace(/ {2}/g, " "))
        ];
        //---- Create Excel ----
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName.replace(/ {2}/g, " ");
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        //---- Hours -----
        addHoursSheet(workbook, mainData, headerArr);
        //---- Mileage -----
        addMileageSheet(workbook, mainData, headerArr);
        //---- Tolls Paid -----
        addTollsSheet(workbook, mainData, headerArr);
        //---- Subsistence -----
        addSubsitenceSheet(workbook, mainData, headerArr);
        //---- Subsistence Billable -----
        addSubsitenceBillableSheet(workbook, mainData, headerArr);
        //----- locator ------
        addLocatorSheet(workbook, "locator");
        //------ qew ------
        addLocatorSheet(workbook, "qew");
        //---- Mob Hours -----
        addMobSheet(workbook, mainData);
        //----------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Outside Service ${week}.xlsx`);
            setShowLoader(false);
        });
    }
    //--------------------------------------------------------------------------------------------
    return(
        <>
        <span className = "pointer" onClick = {handleDataReport}>Data Report</span>
        <span className = "pointer ml-2" onClick = {handleCsvExport}>CSV Export</span>
        </>
    )
}